module.exports = __webpack_public_path__ + "img/1491095135.fb3fa7bb.jpg";